const sales = ['Super Admin', 'Sales Head', 'Advisor'];
const inventory = ['Super Admin', 'Property Ops'];
export const entityWriteRoles: Record<string, readonly string[]> = {
  accounts: sales,
  leads: sales,
  offers: sales,
  contacts: sales,
  opportunities: sales,
  tasks: sales,
  visits: sales,
  interactions: sales,
  properties: inventory,
  suppliers: inventory,
  campaigns: ['Super Admin', 'Marketing'],
  workflows: ['Super Admin', 'Sales Head'],
};
const advisorScoped = new Set([
  'contacts',
  'opportunities',
  'tasks',
  'visits',
  'accounts',
  'leads',
  'offers',
]);
export function canWriteEntity(
  user: { role?: string; name?: string },
  entity: string,
  record?: Record<string, unknown>,
): boolean {
  return (
    Boolean(entityWriteRoles[entity]?.includes(user.role || '')) &&
    !(user.role === 'Advisor' && advisorScoped.has(entity) && record && record.owner !== user.name)
  );
}
export const canManageWorkspace = (role: string) => ['Super Admin', 'Compliance'].includes(role);
export const canReadWebsiteTracking = (role: string) =>
  ['Super Admin', 'Sales Head', 'Marketing', 'Analyst', 'Compliance'].includes(role);
export const canGovernContact = (role: string) =>
  ['Super Admin', 'Sales Head', 'Advisor', 'Compliance'].includes(role);
